import { getBaseUrlByBackend } from "@api/helpers/url/getBaseUrlByBackend";
import * as signalR from "@microsoft/signalr";

export class RealtimeConnection {
    private _hub: signalR.HubConnection;
    private _usedTransport = signalR.HttpTransportType.WebSockets;

    constructor(
        private readonly onClose: () => Promise<void>,
        private readonly backend: string
    ) {
        this._hub = this.getNewConnection(this._usedTransport);
    }

    /**
     * connection instance
     */
    get hub() {
        return this._hub;
    }

    /**
     * transport isntance
     */
    get usedTransport() {
        return this._usedTransport;
    }

    /**
     * Change transport for the new signalr connection
     * @private
     */
    private changeTransport() {
        if (this._usedTransport === Object.keys(signalR.HttpTransportType).length / 2) {
            this._usedTransport = signalR.HttpTransportType.WebSockets;
        } else {
            this._usedTransport *= 2;
        }
    }

    /**
     * Creates new connections
     * @param transport
     * @private
     */
    private getNewConnection(transport: signalR.HttpTransportType = signalR.HttpTransportType.None) {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${getBaseUrlByBackend(this.backend)}/realtime`, transport)
            .build();

        connection.onclose(this.onClose);

        return connection;
    }

    /**
     * Changes the transport and creates new connection to the signalr hub
     */
    reinitialize() {
        this.changeTransport();
        this._hub = this.getNewConnection(this._usedTransport);
    }
}